

const bg = 'https://36kr-zero.oss-cn-beijing.aliyuncs.com/annisersary/audio/bg.mp3'
// const title = 'https://36kr-zero.oss-cn-beijing.aliyuncs.com/annisersary/audio/title.mp3'
const first = 'https://36kr-zero.oss-cn-beijing.aliyuncs.com/annisersary/audio/first.mp3'
const second = 'https://36kr-zero.oss-cn-beijing.aliyuncs.com/annisersary/audio/second.mp3'
const third = 'https://36kr-zero.oss-cn-beijing.aliyuncs.com/annisersary/audio/third.mp3'
const four = 'https://36kr-zero.oss-cn-beijing.aliyuncs.com/annisersary/audio/four.mp3'
const five = 'https://36kr-zero.oss-cn-beijing.aliyuncs.com/annisersary/audio/five.mp3'
const playList = [first, second, third, four, five]


export default {
  state: {
    bgAudio: new Audio(),
    actionAudio: new Audio()
  },
  mutations: {
    bgAudioPlay({bgAudio}) {
      if(!bgAudio.src && bgAudio.paused){
        bgAudio.src = bg
        bgAudio.play()
      }
    },
    actionAudioPlay({actionAudio}, i) {
      actionAudio.src = playList[i]
      actionAudio.play()
    }
  },
  actions: {

  }
}